module.exports = __webpack_public_path__ + "img/NN.7db678cf.png";